import React from 'react';
import { inject, observer } from 'mobx-react';
import { useTranslation } from 'react-i18next';

import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import createStyles from '@material-ui/core/styles/createStyles';
import makeStyles from '@material-ui/core/styles/makeStyles';
import { Theme } from '@material-ui/core/styles';

import compose from 'helpers/compose';
import DialogHeader from 'components/DialogHeader/DialogHeader';
import { UserStoreKC } from 'stores/userStoreKC';
const AppLogo = require('assets/edward-logo.png');

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      '& .MuiDialog-paper, & .MuiDialogContentText-root': {
        background: theme.palette.common.black,
        color: theme.palette.common.white
      },
      '& .MuiDialogContent-root': {
        paddingBottom: theme.spacing(0)
      },
    },
    logo: {
      width: '250px'
    }
  }),
);

interface Props {
  userStore?: UserStoreKC;
  logoutDialogShown: boolean;
  hideLogoutDialog: () => void;
}

const LogoutDialog: React.FC<Props> = ({ userStore, logoutDialogShown, hideLogoutDialog }) => {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <Dialog open={logoutDialogShown} maxWidth="xs" fullWidth className={classes.root}>
      <DialogHeader onClose={hideLogoutDialog} />
      <DialogContent>
        <DialogContentText align="center">
            <img src={AppLogo.default} className={classes.logo} alt='' />
        </DialogContentText>
        <DialogContentText align="center" variant="h6">
          {t('general_logout_confirm')}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
          <Button onClick={()=>userStore?.logout()} color="primary" variant="contained" autoFocus>
          {t('general_logout')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default compose(inject('userStore'), observer)(LogoutDialog);
